/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import api from 'src/services/api';
import { CenteredOverlayLoader } from 'src/components/Loader';
import { Container } from './styles';

interface ReportItemProps {
  name: string;
  link: string;
  suffix: string;
  useAttachmentFileName: boolean;
  buttonName?: string;
  onReportNotFound(): void;
}

const ReportItem: React.FC<ReportItemProps> = ({
  name,
  link,
  suffix,
  useAttachmentFileName,
  buttonName = 'Exportar',
  onReportNotFound,
}) => {
  const [loading, setLoading] = useState(false);
  const onButtonClick = () => {
    setLoading(true);
    window?.dataLayer.push({
      event: 'ReportActions',
      dateUrl: link,
    });
    api
      .get(link, { responseType: 'blob', withCredentials: true })
      .then(response => {
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');

        downloadLink.href = url;
        downloadLink.style.display = 'none';
        let filename = `${name}.${suffix}`;
        if (useAttachmentFileName) {
          const contentDisposition = response.headers[
            'content-disposition'
          ] as string;
          const filenameStartIndex = contentDisposition?.indexOf('=');
          filename =
            contentDisposition?.substring(filenameStartIndex + 1) || filename;
        }
        downloadLink.setAttribute('download', filename);

        document.body.appendChild(downloadLink);
        downloadLink.click();

        setTimeout(() => {
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);
        }, 200);
      })
      .catch(err => {
        if (err?.response?.status === 404) {
          onReportNotFound();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Container style={{ position: 'relative', zIndex: 2 }}>
        <h1>{name}</h1>
        <div
          style={{
            display: 'flex',
            visibility: name ? 'visible' : 'hidden',
            flex: 1,
            height: 1,
            background: 'var(--color-primary-darker)',
            marginRight: 20,
            marginLeft: 20,
          }}
        />
        <button type="button" onClick={onButtonClick}>
          {buttonName}
        </button>
      </Container>
      {loading && <CenteredOverlayLoader />}
    </>
  );
};

export default ReportItem;
